/* global sABC */

'use strict'

import "babel-polyfill"
import "style/url!file?name=semantic/[hash].[ext]!../../semantic/dist/semantic.min.css"
import "script!../../semantic/dist/semantic.min.js"
import "script!../../node_modules/@fnando/sparkline/dist/sparkline.min.js"

import { getURLParameter, isMobileDevice } from "./utils"
import riot from "riot"
import { config } from "./config"
import "./elements/channelselect.tag"
import "./elements/metadaten.tag"
import "./elements/skipstats.tag"

let debug = false
let station = ""

let urlmatch = window.location.hostname.match(/(.+).player\.streamabc\.com/)
if (urlmatch !== null) {
  station = urlmatch[1]
}

if (getURLParameter("config")) {
  station = getURLParameter("config")
}

if (getURLParameter("debug")) {
  debug = true
}

if (!station) {
    station = "default"
}

const channels = config[station]

let radio = new sABC.Radio({
    debug: debug,
    radioplayer: false
},{ debug: debug, buffertime: 30, buffertimeuser: 90 })

radio.setChannel(channels[Object.keys(channels)[0]],'lq')

riot.mount("*", { channels: channels, radio: radio, debugMsg: debugMsg, debug: debug })

$(function() {

    let skipped = false

    debugMsg(`Setze Hintergrund auf ${channels[Object.keys(channels)[0]].bgcolor}`)
    $('body').css('background-color', channels[Object.keys(channels)[0]].bgcolor)
    $('#header').prop('src', channels[Object.keys(channels)[0]].header)
    //$(".startup").transition('fade')

    if (!isMobileDevice() && (!window.navigator.userAgent.match(/Safari/) || window.navigator.userAgent.match(/Chrome/))) {
        debugMsg("Autoplay-fähiger Browser")
        setTimeout(() => {
          $('.ui.dropdown.channel').dropdown('set selected', Object.keys(channels)[0])
        }, 1000)
    } else {
        debugMsg("Kein Autoplay")
    }

    $('.login-info').on("click", (e) => {
        e.preventDefault()
        $("#LoginInfo").modal("show")
    });

    if (debug) {
      $(".debug").show()
    }

    radio.on("play", (data) => {
        debugMsg("[Event] play")
        console.log(data)
        $("#PlayPause span").text("Stop")
        $("#PlayPause i").removeClass("play").addClass("stop")
        $("#Type").show()
        $(".time").show()
        if (skipped) {
            $(".streamtype").text("User-Stream")
        } else {
            if (data.channel.ondemand) {
              $(".live").removeClass("disabled")
              $(".streamtype").text("OnDemand-Song")
            } else {
              $(".streamtype").text("Live-Stream")
            }
        }
    })

    radio.on("adstarted", (duration) => {
        $(".streamtype").text("Werbung")
    })

    radio.on("adfinished", () => {
      if (skipped) {
          $(".streamtype").text("User-Stream")
      } else {
          $(".streamtype").text("Live-Stream")
      }
    })

    radio.on("stop", () => {
        debugMsg("[Event] stop")
        $("#PlayPause span").text("Play")
        $("#PlayPause i").removeClass("stop").addClass("play")
        $(".time").text("")
        //$("#Loading").removeClass("active")
        $("#Playing .meta").text("")
        $("#Type").text("Player gestoppt")
    })

    radio.on("pause", () => {
        debugMsg("[Event] pause")
        $("#Loading").removeClass("active")
        $("#PlayPause span").text("Play")
        $("#PlayPause i").removeClass("stop").addClass("play")
        //$("#Loading").removeClass("active")
        $(".time").hide()
    })

    radio.on("skippable", (skippable) => {
        debugMsg(`[Event] skippable ${skippable}`)
        if (skippable) {
            $(".skip").removeClass("disabled")
        } else {
            $(".skip").addClass("disabled")
        }
    })

    radio.on("skippable-back", function(skippable) {
      debugMsg(`[Event] skippable-back ${skippable}`)
        if (skippable.enabled) {
            $(".skip-back").removeClass("disabled")
            if (skippable.pos === 0) {
                $(".skip-back").attr("title","Skippe zum Anfang des aktuellen Songs")
            } else {
                $(".skip-back").attr("title","Skippe zum vorherigen Song")
            }
        } else {
            $(".skip-back").addClass("disabled")
        }
    })

    radio.on("loading", () => {
        debugMsg("[Event] loading")
        $(".time").text("")
        $("#Loading").addClass("active")
    })

    radio.on("ready", () => {
        debugMsg("[Event] ready")
        $("#Loading").removeClass("active")
    })

    radio.on("error", (error) => {
        debugMsg("[Event] ready")
        $("#Loading").removeClass("active")
        $("#PlayPause span").text("Play")
        $("#PlayPause i").removeClass("stop").addClass("play")
        $("#Type").text("Ein Fehler ist aufgetreten: " + error)
        $("#Playing .meta").text("")
    })

    radio.on("skip", () => {
        debugMsg("[Event] skip")
        $(".time").text("Song wird geskippt")
        $("#Loading").addClass("active")
    })

    radio.on("streamtype", (data) => {
      debugMsg("[Event] streamtype")
      console.log(data)
      skipped = data.skipped
        if (data.skipped) {
            $(".streamtype").text("User-Stream")
            $(".live").removeClass("disabled")
        } else {
            $(".streamtype").text("Live-Stream")
            $(".live").addClass("disabled")
        }
    })

    radio.on("playing", (duration) => {
        let hours = Math.floor(duration / 3600)
        duration = duration - hours * 3600
        let minutes = Math.floor(duration / 60)
        let seconds = duration - minutes * 60
        const playtime = `${str_pad_left(hours,"0",2)}:${str_pad_left(minutes,"0",2)}:${str_pad_left(seconds,"0",2)}`
        $(".time").html(playtime)
    })

    radio.init().then(() => {

        debugMsg("ListenerID = " + radio.sabcService.getUserID())
        $(".listenerid").text(`ListenerID: ${radio.sabcService.getUserID()}`)

        $("#PlayPause").on("click", (e) => {
            e.preventDefault()

            if (!$("input[name=channel]").val()) {
                $('#ChannelInfo').modal('setting', 'closable', false).modal('show')
            } else {
                radio.setChannel(channels[$("input[name=channel]").val()], "lq")
                radio.toggle()
            }

        })

        $("#Skip").on("click", (e) => {
            e.preventDefault()
            radio.skip()
        })

        $("#Live").on("click", (e) => {
            e.preventDefault()
            radio.switch(channels[$("input[name=channel]").val()], "lq")
        })

        $("#SkipBack").on("click", (e) => {
            e.preventDefault()
            radio.skipBack()
        })

    })

 })

function str_pad_left(string,pad,length) {
    return (new Array(length+1).join(pad)+string).slice(-length);
}

function debugMsg(msg) {
    if (debug) {
        console.log(`[${new Date()}]  ${msg}`)
    }
}



// WEBPACK FOOTER //
// ./src/js/main.js